import Features from "./Components/Features";
import Footer from "./Components/Footer";
import { LandingPage } from "./Components/LandingPage";
import { StickyNavbar } from "./Components/NavBar";
import Newsletter from "./Components/NewsLetter";
import Testimonials from "./Components/Testimonials";
import Zigzag from "./Components/Zigzag";

const Home=()=>{
    return(
        <div className="App">
            <StickyNavbar />
            <LandingPage />
            <Features shownavbar={false}/>
            <Zigzag />
      <Testimonials />
      <Newsletter />
      <Footer />
        </div>
    )
};
export default Home;